import {Image} from '@/_application/core/components/ui/image';
import React from 'react';

export type ImageRectangle = {
    src: string;
    alt: string;
};

interface IProps {
    title: string;
    items: ImageRectangle[];
}

function FooterImageRectangleBlock({title, items}: Readonly<IProps>) {
    return (
        <div>
            <p className="text-[14px] font-bold uppercase leading-[19px] text-primary">{title}</p>
            <div className="mt-3 flex flex-wrap gap-4">
                {items.map(item => (
                    <Image key={item.alt} src={item.src} alt={item.alt} width={60} height={30} />
                ))}
            </div>
        </div>
    );
}

export default FooterImageRectangleBlock;
